(function () {
  'use strict';

  var TABLET_QUERY = '(max-width: 1024px)';
  var TOUCH_CLICK_WINDOW = 800;

  function directChild(parent, selector) {
    var children = parent ? parent.children : [];
    var index;

    for (index = 0; index < children.length; index += 1) {
      if (children[index].matches(selector)) return children[index];
    }
    return null;
  }

  function isPhase8() {
    return document.body &&
      document.body.getAttribute('data-kjs-card-phase') === '8';
  }

  function setInert(node, state) {
    if (!node) return;
    if ('inert' in node) node.inert = state;
    if (state) node.setAttribute('aria-hidden', 'true');
    else node.removeAttribute('aria-hidden');
  }

  function itemParts(item) {
    var link = directChild(item, 'a');
    var button = directChild(item, '.kjs-submenu-toggle');
    var submenu = directChild(item, 'ul');

    if (!link || !button || !submenu) return null;
    return { link: link, button: button, submenu: submenu };
  }

  function setExpanded(item, expanded) {
    var parts = itemParts(item);
    var label;
    var symbol;

    if (!parts) return;

    item.classList.toggle('kjs-submenu-open', expanded);
    parts.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    parts.link.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    label = parts.link.textContent.replace(/\s+/g, ' ').trim();
    parts.button.setAttribute(
      'aria-label',
      (expanded ? 'Hide ' : 'Show ') + label + ' subcategories'
    );

    symbol = parts.button.querySelector('span');
    if (symbol) symbol.textContent = expanded ? '\u2212' : '+';

    if (window.matchMedia(TABLET_QUERY).matches) {
      parts.submenu.hidden = !expanded;
    } else {
      parts.submenu.hidden = false;
    }

    if (!expanded) {
      /* Clear ShowTime's parallel desktop state so it cannot immediately
       * reveal a submenu that the Phase 8 controller has just closed. */
      item.classList.remove('hover');
      parts.link.classList.remove('menu-clicked');

      Array.prototype.forEach.call(
        item.querySelectorAll('li.kjs-submenu-open'),
        function (childItem) {
          setExpanded(childItem, false);
        }
      );
    }
  }

  function closeSiblingMenus(item) {
    var siblings = item && item.parentElement ? item.parentElement.children : [];

    Array.prototype.forEach.call(siblings, function (sibling) {
      if (sibling !== item && sibling.matches('li.kjs-submenu-open')) {
        sibling.removeAttribute('data-kjs-v8-menu-armed');
        setExpanded(sibling, false);
      }
    });
  }

  function closeDesktopMenus(exceptItem) {
    var items = document.querySelectorAll(
      '#KjsPrimaryNavigation > .wsmenu-list > li.kjs-submenu-open'
    );

    Array.prototype.forEach.call(items, function (item) {
      if (item === exceptItem) return;
      item.removeAttribute('data-kjs-v8-menu-armed');
      setExpanded(item, false);
    });
  }

  function keepMobileDrawerOpen() {
    var body = document.body;
    var container = document.querySelector('.wsmenucontainer');
    var drawer = document.getElementById('KjsPrimaryNavigation');
    var mainToggle = document.getElementById('wsnavtoggle');
    var searchDock = document.querySelector('[data-kjs-search-dock]');

    if (!window.matchMedia(TABLET_QUERY).matches) return;

    body.classList.add('kjs-nav-open');
    if (container) container.classList.add('wsoffcanvasopener');
    if (mainToggle) {
      mainToggle.setAttribute('aria-expanded', 'true');
      mainToggle.setAttribute('aria-label', 'Close departments menu');
    }
    setInert(drawer, false);
    setInert(searchDock, true);
  }

  function closeMobileDrawer() {
    var body = document.body;
    var container = document.querySelector('.wsmenucontainer');
    var drawer = document.getElementById('KjsPrimaryNavigation');
    var mainToggle = document.getElementById('wsnavtoggle');
    var searchDock = document.querySelector('[data-kjs-search-dock]');

    if (!window.matchMedia(TABLET_QUERY).matches) return;

    body.classList.remove('kjs-nav-open');
    if (container) container.classList.remove('wsoffcanvasopener');
    if (mainToggle) {
      mainToggle.setAttribute('aria-expanded', 'false');
      mainToggle.setAttribute('aria-label', 'Open departments menu');
    }
    setInert(drawer, true);
    setInert(searchDock, false);

    Array.prototype.forEach.call(
      document.querySelectorAll('#KjsPrimaryNavigation li.kjs-submenu-open'),
      function (item) {
        setExpanded(item, false);
      }
    );
  }

  function toggleMobileDrawer() {
    if (document.body.classList.contains('kjs-nav-open')) {
      closeMobileDrawer();
    } else {
      keepMobileDrawerOpen();
    }
  }

  function activateSubmenuButton(button) {
    var item = button.closest('li');
    var expanded;

    if (!item) return;
    expanded = !item.classList.contains('kjs-submenu-open');

    if (expanded) closeSiblingMenus(item);
    setExpanded(item, expanded);
    keepMobileDrawerOpen();
  }

  function findSubmenuButton(target) {
    return target && target.closest
      ? target.closest('#KjsPrimaryNavigation .kjs-submenu-toggle')
      : null;
  }

  function findDesktopDepartmentLink(target) {
    var link;
    var item;

    if (window.matchMedia(TABLET_QUERY).matches || !target || !target.closest) {
      return null;
    }

    link = target.closest('#KjsPrimaryNavigation > .wsmenu-list > li > a[aria-haspopup="true"]');
    item = link && link.parentElement;
    return item && itemParts(item) ? link : null;
  }

  function initializeNavigationRepair() {
    var body = document.body;

    if (!isPhase8() || body.getAttribute('data-kjs-v8-nav-bound') === 'true') {
      return;
    }
    body.setAttribute('data-kjs-v8-nav-bound', 'true');

    /*
     * Run the main drawer control at window capture, before ShowTime's
     * document-level handlers. Otherwise the legacy handler changes the body
     * state first and a later controller can inadvertently reverse the user's
     * requested open/close action.
     */
    window.addEventListener('touchend', function (event) {
      var mainToggle = event.target && event.target.closest
        ? event.target.closest('#wsnavtoggle')
        : null;
      var submenuButton = findSubmenuButton(event.target);

      if (
        (!mainToggle && !submenuButton) ||
        !window.matchMedia(TABLET_QUERY).matches
      ) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (mainToggle) {
        mainToggle.setAttribute('data-kjs-v8-touch-time', String(Date.now()));
        toggleMobileDrawer();
      } else {
        submenuButton.setAttribute(
          'data-kjs-v8-touch-time',
          String(Date.now())
        );
        activateSubmenuButton(submenuButton);
      }
    }, true);

    window.addEventListener('click', function (event) {
      var mainToggle = event.target && event.target.closest
        ? event.target.closest('#wsnavtoggle')
        : null;
      var overlay = event.target && event.target.closest
        ? event.target.closest('.overlapblackbg')
        : null;
      var submenuButton = findSubmenuButton(event.target);
      var lastTouch;

      if (!window.matchMedia(TABLET_QUERY).matches) return;

      if (mainToggle) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        lastTouch = Number(
          mainToggle.getAttribute('data-kjs-v8-touch-time') || 0
        );
        if (Date.now() - lastTouch > TOUCH_CLICK_WINDOW) {
          toggleMobileDrawer();
        }
        return;
      }

      if (submenuButton) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        lastTouch = Number(
          submenuButton.getAttribute('data-kjs-v8-touch-time') || 0
        );
        if (Date.now() - lastTouch > TOUCH_CLICK_WINDOW) {
          activateSubmenuButton(submenuButton);
        }
        return;
      }

      if (overlay && document.body.classList.contains('kjs-nav-open')) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        closeMobileDrawer();
      }
    }, true);

    /*
     * ShowTime also listens for touch events on the parent list items. Capture
     * submenu touches before those legacy handlers can close or redirect the
     * drawer, then suppress the synthetic click generated by the same tap.
     */
    document.addEventListener('touchend', function (event) {
      var button = findSubmenuButton(event.target);
      var mainToggle = event.target && event.target.closest
        ? event.target.closest('#wsnavtoggle')
        : null;

      if (!button && !mainToggle) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (mainToggle && window.matchMedia(TABLET_QUERY).matches) {
        mainToggle.setAttribute('data-kjs-v8-touch-time', String(Date.now()));
        toggleMobileDrawer();
        return;
      }

      button.setAttribute('data-kjs-v8-touch-time', String(Date.now()));
      activateSubmenuButton(button);
    }, true);

    document.addEventListener('click', function (event) {
      var button = findSubmenuButton(event.target);
      var mainToggle = event.target && event.target.closest
        ? event.target.closest('#wsnavtoggle')
        : null;
      var lastTouch;
      var link;
      var item;
      var open;
      var armed;

      if (mainToggle && window.matchMedia(TABLET_QUERY).matches) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        lastTouch = Number(
          mainToggle.getAttribute('data-kjs-v8-touch-time') || 0
        );
        if (Date.now() - lastTouch > TOUCH_CLICK_WINDOW) {
          toggleMobileDrawer();
        }
        return;
      }

      if (button) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        lastTouch = Number(button.getAttribute('data-kjs-v8-touch-time') || 0);
        if (Date.now() - lastTouch > TOUCH_CLICK_WINDOW) {
          activateSubmenuButton(button);
        }
        return;
      }

      link = findDesktopDepartmentLink(event.target);
      if (!link) {
        if (
          !window.matchMedia(TABLET_QUERY).matches &&
          !event.target.closest('#KjsPrimaryNavigation')
        ) {
          closeDesktopMenus(null);
        }
        return;
      }

      item = link.parentElement;
      open = item.classList.contains('kjs-submenu-open');
      armed = item.getAttribute('data-kjs-v8-menu-armed') === 'true';

      /*
       * The first desktop click opens the submenu. A second click on the same
       * already-open department keeps the original collection link available.
       */
      if (open && armed) {
        item.removeAttribute('data-kjs-v8-menu-armed');
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      closeSiblingMenus(item);
      setExpanded(item, true);
      item.setAttribute('data-kjs-v8-menu-armed', 'true');
    }, true);

    document.addEventListener('keydown', function (event) {
      var mainToggle;
      var openItem;
      var parts;

      if (event.key !== 'Escape') return;

      if (window.matchMedia(TABLET_QUERY).matches) {
        if (document.body.classList.contains('kjs-nav-open')) {
          mainToggle = document.getElementById('wsnavtoggle');
          closeMobileDrawer();
          if (mainToggle) mainToggle.focus();
          event.preventDefault();
          event.stopPropagation();
          return;
        }
        openItem = document.querySelector(
          '#KjsPrimaryNavigation li.kjs-submenu-open'
        );
      } else {
        openItem = document.querySelector(
          '#KjsPrimaryNavigation > .wsmenu-list > li.kjs-submenu-open'
        );
      }

      if (!openItem) return;
      parts = itemParts(openItem);
      if (parts) parts.link.focus();
      openItem.removeAttribute('data-kjs-v8-menu-armed');
      setExpanded(openItem, false);
      event.preventDefault();
      event.stopPropagation();
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeNavigationRepair);
  } else {
    initializeNavigationRepair();
  }
  document.addEventListener('shopify:section:load', initializeNavigationRepair);
})();

